exports.componentPropsPlugin = require('../lib/next-config/plugins/component-props');
exports.corsHeaderPlugin = require('../lib/next-config/plugins/cors-header');
exports.corsPlugin = require('../lib/next-config/plugins/cors');
exports.feaasPlugin = require('../lib/next-config/plugins/feaas');
exports.graphqlPlugin = require('../lib/next-config/plugins/graphql');
exports.robotsPlugin = require('../lib/next-config/plugins/robots');
exports.sassPlugin = require('../lib/next-config/plugins/sass');
exports.sitemapPlugin = require('../lib/next-config/plugins/sitemap');
exports.svgrPlugin = require('../lib/next-config/plugins/svgr');
